import { RefObject, useCallback } from 'react';
import { Promotion } from 'types/utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { useIntersectionObserver } from './use-intersection-observer';

/**
 * Отправка события "GA:promoView" при попадании елемента во вью порт
 * @param {RefObject<HTMLElement[]>} refs
 * @param {string}                   elementBlock
 * @param {Promotion[]}              promotions
 * @param {number}                   [lastRefIndex]
 * @param {IntersectionObserverInit} [options]
 */
export const usePromoViewEvent = (
  refs: RefObject<HTMLElement[]>,
  elementBlock: string,
  promotions: Promotion[],
  lastRefIndex = 0,
  options?: IntersectionObserverInit
) => {
  const intersectionObserverCallback = useCallback(
    (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      const gaPromotions: Promotion[] = [];
      entries.forEach(({ isIntersecting, target }: IntersectionObserverEntry) => {
        if (isIntersecting) {
          const position: string | null = target.getAttribute('data-position');

          if (position) {
            gaPromotions.push(promotions[Number(position)]);
            observer.unobserve(target);
          }
        }
      });

      if (gaPromotions.length) {
        analyticsUtils.sendEvent('GA:promoView', {
          elementType: 'banner',
          elementBlock,
          promotions: gaPromotions,
        });
      }
    },
    [elementBlock, promotions]
  );

  useIntersectionObserver(refs, intersectionObserverCallback, options, lastRefIndex);
};
